import { Flex, FlexProps } from 'antd';
import clsx from 'clsx';
import { FC, ReactNode } from 'react';

import styles from './styles.module.scss';

interface IEmptyStateProps extends Omit<FlexProps, 'children' | 'content'> {
    content: ReactNode;
    actions?: ReactNode;
}

export const EmptyState: FC<IEmptyStateProps> = ({ content, actions, ...props }) => {
    return (
        <Flex className={clsx(styles.empty, props.className)} {...props}>
            {content}
            {actions}
        </Flex>
    );
};
